export default __webpack_public_path__ + "static/media/Draw of Fangs.504cba57.jpg";